module.exports = __webpack_public_path__ + "media/images/icons/info-f807974b901c8a34915c1dde4b04bde2.svg";